import type { ConceptDef } from '../types';

export const mandInformation: ConceptDef = {
  kind: 'supervisorScored',
  id: 'mand-information',
  label: 'Mand Information',
  category: 'Mand',
  description: 'Set up a context; learner asks a Wh-question. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'A new toy is in a closed box.', hint: 'Expect: "What is in the box?"' },
      { prompt: 'A loud sound came from the kitchen.', hint: 'Expect: "What was that?"' },
      { prompt: 'A new person walks into the room.', hint: 'Expect: "Who is that?"' },
      { prompt: 'You see a wrapped present.', hint: 'Expect: "What is it?"' },
      { prompt: 'A treat is hidden — somewhere.', hint: 'Expect: "Where is it?"' },
    ],
  },
};
